import UserWelcome from './UserWelcome';
import React from 'react';
import { Link } from 'react-router-dom';
import ProtectedComponent from '../ProtectedComponent';
import { isOnRoute } from '../../utils/navigationUtils';

class RightNav extends ProtectedComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      mobileMenuOpen: false
    };
  }

  toggleMobileMenu = () => {
    const newState = !this.state.mobileMenuOpen;
    this.setState({ mobileMenuOpen: newState });

    if (newState) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  };

  closeMobileMenu = () => {
    this.setState({ mobileMenuOpen: false });
    document.body.classList.remove('mobile-menu-open');
  };

  handleChangePasswordClick = () => {
    if (isOnRoute('change-password')) {
      window.location.reload(true);
    }
    this.closeMobileMenu();
  };

  componentWillUnmount() {
    document.body.classList.remove('mobile-menu-open');
    super.componentWillUnmount && super.componentWillUnmount();
  }

  render() {
    if (!this.state.user) {
      return null;
    }

    const currentLocation = window.location.pathname;
    const navClasses = `right-nav ${this.state.mobileMenuOpen ? 'mobile-nav-open' : ''}`;

    return (
      <React.Fragment>
        <button className="mobile-menu-toggle" onClick={this.toggleMobileMenu} aria-label="Toggle mobile menu">
          <div className={`hamburger ${this.state.mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>

        <ul className={navClasses}>
          <li onClick={this.closeMobileMenu}>
            <Link to="/">Dashboard</Link>
            <div className={'/' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>
          <li onClick={this.closeMobileMenu}>
            <Link to="/reservations">Rides</Link>
            <div className={'/reservations' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>
          <li onClick={this.closeMobileMenu}>
            <Link to="/invoices">Invoices</Link>
            <div className={'/invoices' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>
          {/* <li onClick={this.closeMobileMenu}>
            <Link to="/apps">Request App Access</Link>
            <div className={'/apps' === currentLocation ? 'current-page' : null} />
          </li> */}
          <li onClick={this.closeMobileMenu}>
            <Link to="/pick-up-calculator">Pickup Calculator</Link>
            <div className={'/pick-up-calculator' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>

          <li className="mobile-user-welcome">
            <span>Welcome, {this.state.user ? this.state.user.name : 'User'}</span>
          </li>
          <li className="mobile-sub-item" onClick={this.closeMobileMenu}>
            <Link to="/credit-cards">Manage Credit Cards</Link>
            <div className={'/credit-cards' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>
          <li className="mobile-sub-item" onClick={this.handleChangePasswordClick}>
            <Link to="/change-password">Change Password</Link>
            <div className={'/change-password' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>
          <li className="mobile-sub-item" onClick={this.closeMobileMenu}>
            <Link to="/sign-out">Sign Out</Link>
            <div className={'/sign-out' === currentLocation ? 'current-page-active' : 'current-page'} />
          </li>

          <li className="desktop-user-welcome">
            <UserWelcome closeMobileMenu={this.closeMobileMenu} />
          </li>
        </ul>
      </React.Fragment>
    );
  }
}

export default RightNav;
